import React from 'react'
import PropTypes from 'prop-types'
import { Row } from '@fs/zion-ui'
import { useSlsStateContext, getSlsTypeByValue } from '@fs/zion-sls'
import { getFieldTypeValuesObjects } from '../utils/helpers'

/**
 * ReviewDetailsRow component displays review details for a person in a formatted row layout.
 * Renders rows for each field type specified in fieldTypesArray, showing the field label and value.
 * Each detail is conditionally rendered only if a value is provided.
 *
 * @component
 * @param {Object} props - Component props
 * @param {Object} props.person - The person object containing field values
 * @param {string[]} props.fieldTypesArray - Array of field type strings to display (e.g., ["SEX_CODE", "RACE_OR_COLOR"])
 * @returns {React.ReactElement} Fragment containing review detail rows with formatted field labels and values
 *
 * @example
 * <ReviewDetailsRow person={personObject} fieldTypesArray={["SEX_CODE", "RACE_OR_COLOR"]} />
 */
const ReviewDetailsRow = ({ person, fieldTypesArray, showLabel = true }) => {
  const fieldTypeValueObjects = getFieldTypeValuesObjects(person, fieldTypesArray)
  const { types } = useSlsStateContext()

  return (
    <>
      {fieldTypeValueObjects.map(({ fieldType, fieldValue }) => {
        if (!fieldValue) return null
        return (
          <Row guttersY="pico" key={`personal-detail-${fieldType}`}>
            {showLabel
              ? `${getSlsTypeByValue(fieldType, 'fields', types)?.displayLabel || fieldType}: ${fieldValue}`
              : fieldValue}
          </Row>
        )
      })}
    </>
  )
}

ReviewDetailsRow.propTypes = {
  person: PropTypes.shape({}).isRequired,
  fieldTypesArray: PropTypes.arrayOf(PropTypes.string).isRequired,
  showLabel: PropTypes.bool,
}
export default ReviewDetailsRow
